<p-dialog [visible]="showDailog()" [closeOnEscape]="false" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'1199px': '100vw'}" [style]="{width: '740px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">


    <!-- Header -->
    <div class="p-3 flex align-items-center border-bottom-1 border-300 flex align-items-center justify-content-between">
      <h2 class="mb-0 text-sm">{{'OPPORTUNITY.LOSTDEAL.LOST_LEAD_REASON' | translate}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeAllDialogs()" data-testid="close-lost-deal-reason-button"></div>
    </div>
    <!-- Header -->

    <!-- Header -->
    <!-- <div class="flex align-items-center justify-content-between py-2 px-3">
    <div class="flex align-items-center my-1">
      <span class="mr-2" *ngIf="lostDealInfo.client_info && lostDealInfo.client_info.image"><img class="border-circle" width="32" [src]="lostDealInfo.client_info.image" alt="Avatar" /></span>
      <span class="text-primary font-bold text-base mr-2" *ngIf="lostDealInfo">{{lostDealInfo.client_info.full_name}}</span>
      <span class="text-600 font-normal text-sm" *ngIf="lostDealInfo">{{'OPPORTUNITY.LOSTDEAL.CLIENT_ID' | translate}} - {{lostDealInfo.client_info.id}}</span>
    </div>
    <div [innerHTML]="clientStatus(lostDealInfo.client_info)"></div>
  </div> -->
  <!-- Header -->

  <div class="surface-0 border-round shadow-3 m-3">

    <div class="flex align-items-center justify-content-between p-3">
      <div class="flex align-items-center">
        @if (lostDealInfo().client_info && lostDealInfo().client_info.image) {
          <span class="mr-2"><img class="border-circle" width="32" [src]="lostDealInfo().client_info.image" alt="Avatar" /></span>
        }
        @if (lostDealInfo() && lostDealInfo().client_info) {
          <span class="text-primary font-bold text-base mr-2">{{lostDealInfo().client_info.full_name}}</span>
        }
        @if (lostDealInfo() && lostDealInfo().client_info) {
          <span class="text-600 font-normal text-sm"> - {{lostDealInfo().client_info.id}}</span>
        }
      </div>
      <div class="flex align-items-center">
        @if (lostDealInfo() && lostDealInfo().client_info) {
          <div [innerHTML]="clientStatus(lostDealInfo().client_info)"></div>
        }
      </div>
    </div>

  </div>


  <!-- Content -->
  <div class="p-3 md:py-5 surface-100 border-top-1 border-300">
    <div class="grid">

      <div class="col-12 md:col-6">
        <div
          class="surface-0 border-2 border-300 border-round p-2 flex align-items-center line-height-1 cursor-pointer hover:bg-primary hover:border-primary transition-all transition-duration-300"
          (click)=" showReasonDailog('lost-to-competitor-img', 'lost to competitors')"
          data-testid="lost-to-competitor-button"
          >
          <span
            class="h-2rem w-2rem bg-primary flex align-items-center justify-content-center border-round transition-all transition-duration-300">
            <i class="fa fa-user-minus text-sm"></i>
          </span>
          <strong class="ml-3 transition-all transition-duration-300">{{'OPPORTUNITY.LOSTDEAL.LOST_TO_COMPETITORS' | translate}}</strong>
        </div>
      </div>


      <div class="col-12 md:col-6">
        <div
          class="surface-0 border-2 border-300 border-round p-2 flex align-items-center line-height-1 cursor-pointer hover:bg-primary hover:border-primary transition-all transition-duration-300"
          (click)="showReasonDailog('lost-to-high-price', 'Lost due to Price High')"
          data-testid="lost-to-high-price-button"
          >
          <span
            class="h-2rem w-2rem bg-primary flex align-items-center justify-content-center border-round transition-all transition-duration-300">
            <i class="fa fa-sack-dollar"></i>
          </span>
          <strong class="ml-3 transition-all transition-duration-300">{{'OPPORTUNITY.LOSTDEAL.HIGH_PRICE' | translate}}</strong>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div
          class="surface-0 border-2 border-300 border-round p-2 flex align-items-center line-height-1 cursor-pointer hover:bg-primary hover:border-primary transition-all transition-duration-300"
          (click)="showReasonDailog('lost-to-missing-facility-img', 'Missing Facility')"
          data-testid="lost-to-missing-facility-button"
          >
          <span
            class="h-2rem w-2rem bg-primary flex align-items-center justify-content-center border-round transition-all transition-duration-300">
            <i class="fa fa-question"></i>
          </span>
          <strong
          class="ml-3 transition-all transition-duration-300 transition-all transition-duration-300">{{'OPPORTUNITY.LOSTDEAL.MISSING_FACILITY' | translate}}</strong>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div
          class="surface-0 border-2 border-300 border-round p-2 flex align-items-center line-height-1 cursor-pointer hover:bg-primary hover:border-primary transition-all transition-duration-300"
          (click)="showReasonDailog('lost-to-other-reasons-img', 'Lost to Other Reasons')"
          data-testid="lost-to-other-reasons-button"
          >
          <span
            class="h-2rem w-2rem bg-primary flex align-items-center justify-content-center border-round transition-all transition-duration-300">
            <i class="fa fa-ellipsis"></i>
          </span>
          <strong class="ml-3 transition-all transition-duration-300">{{'OPPORTUNITY.LOSTDEAL.OTHER_REASON' | translate}}</strong>
        </div>
      </div>


      <div class="col-12 md:col-6">
        <div
          class="surface-0 border-2 border-300 border-round p-2 flex align-items-center line-height-1 cursor-pointer hover:bg-primary hover:border-primary transition-all transition-duration-300"
          (click)="showReasonDailog('lost-to-no-contactable-img', 'Not Contactable')"
          data-testid="lost-to-no-contactable-button"
          >
          <span
            class="h-2rem w-2rem bg-primary flex align-items-center justify-content-center border-round transition-all transition-duration-300">
            <i class="fa fa-phone-slash"></i>
          </span>
          <strong class="ml-3 transition-all transition-duration-300">{{'OPPORTUNITY.LOSTDEAL.NOT_CONTACTABLE' | translate}}</strong>
        </div>
      </div>

    </div>
  </div>
  <!-- Content -->

</ng-template>

</p-dialog>
@if (lostDealReason | async) {
  <app-lost-deal-reason [reason]="lostDealReason | async" [showLostReason]="togglelostReason" [dealInfo]="lostDealInfo()" (goBack)="closeReasonDialog()" (closeDailogs)="closeAllDialogs()" (reloadData)="reloadData()" />
}
